module.exports = __webpack_public_path__ + "assets/img/37_338_big.d5fcdbd4.jpg";